import { IGNORED_ATTRIBUTES } from "../../config.js";

/**
 * Sammelt alle Attribute vom [component] Parent-Element (außer component, product-list, ignored)
 *
 * Diese Funktion wird verwendet um zusätzliche Dimensionen/Attribute vom component-Element
 * auf Event-Ebene zu übernehmen für item-basierte Ecommerce Events.
 *
 * Beispiel:
 * <div component="test" cd-filter="preis:24€" demo="123">
 *   <button dl-event="add_to_cart">Add</button>
 * </div>
 *
 * → { filter: "preis:24€", demo: "123" }
 *
 * Hinweis: Legacy-Prefix-Entfernung (cd-, tracking-, etc.) und Key-Transformation (- zu _)
 * werden durch DataLayerEvent automatisch durchgeführt.
 *
 * @param {HTMLElement} element - Das Element, von dem aus nach [component] gesucht wird
 * @returns {Object} Objekt mit allen relevanten Attributen vom component-Element
 */
export function collectComponentAttributes(element) {
	const attributes = {};

	if (!element) {
		return attributes;
	}

	// Finde das component Element
	const componentElement = element.closest("[component]");
	if (!componentElement || !componentElement.attributes) {
		return attributes;
	}

	// Sammle alle Attribute außer component, product-list und ignored
	for (const attr of componentElement.attributes) {
		const name = attr.name;
		const value = attr.value;

		// Leere Werte ignorieren
		if (!value) {
			continue;
		}

		// component und product-list werden separat behandelt
		if (name === "component" || name === "product-list") {
			continue;
		}

		// Ignorierte Attribute überspringen
		if (IGNORED_ATTRIBUTES.includes(name)) {
			continue;
		}

		attributes[name] = value;
	}

	return attributes;
}
